import React, {Fragment} from 'react'
//import PropTypes from 'prop-types'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Alert from '@material-ui/lab/Alert'
const Functions = require('../../shared/Functions.js')
//const _ = require('lodash')
const $ = require('jquery')

const aStyle = {
  display: 'none',
}

const h2Style = {
  display: 'none',
}

const checkStyle = {
  marginRight: '5px',
}

const colorStyle = {
  backgroundColor: '#d9d9d9',
}

const LoginForm = () => <Formik initialValues={{ email: '', password: '', remember_me: false}} enableReinitialize={true} validate={values => {
      const errors = {}
      if (!values.email) {
        errors.email = 'Required'
      } else if (!values.password) {
        errors.password = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      const formData = new FormData()
      formData.append('email', values.email)
      formData.append('password', values.password)
      formData.append('remember_me', values.remember_me)
      $.ajax({
        method: 'POST',
        url: '/users/sign_in.json',
        data: {
          user: {
            email: values.email,
            password: values.password,
            remember_me: values.remember_me,
          },
          authenticity_token: Functions.getMetaContent('csrf-token'),
        },
      })
      .fail((data, textStatus, xhr) => {
        if (xhr === 'Unauthorized') {
          if (data.responseText === '{"error":"Invalid Email or password."}'){
            $('#myerrorsignup').show()
          } else {
            $('#myerrorsignupactivated').show()
          }
        }
      })
      .done(() => {
        const redirectBack = sessionStorage.getItem('redirect_back')
        if (redirectBack) {
          sessionStorage.removeItem('redirect_back')
          window.location.href = redirectBack
        } else {
          window.location.href = '/'
        }
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)
      /*fetch(urlf, {
        method: meth,
        body: formData,
      })
      .then(response => response.json())
      .then((data) => {
        console.log(data)
        document.getElementById('mylink').click()
      })
      .catch((err) => {
        console.log('Error while logging in! ' + err)
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)*/
    }}>{({ isSubmitting, errors, values}) => <Fragment><a href="/" id="mylink" style={aStyle}></a><div id="myerrorsignup" style={h2Style}><Alert color="error">Email/Password combination is invalid!</Alert></div><div id="myerrorsignupactivated" style={h2Style}><Alert color="error">Your account has not been activated or approved by an admin yet!</Alert></div><div style={colorStyle} className="card rounded-card"><div className="card-body"><h2 className="card-title">Log in</h2><br /><Form><div className="form-group"><Field type="text" name="email" placeholder="Email" className={'form-control' + (errors.email ? ' is-invalid' : '')}></Field></div><ErrorMessage name="email" component="div"></ErrorMessage><br /><div className="form-group"><Field type="password" name="password" placeholder="Password" className={'form-control' + (errors.password ? ' is-invalid' : '')}></Field></div><ErrorMessage name="password" component="div"></ErrorMessage><br /><div className="row col-sm-12"><span><Field name="remember_me" component="input" type="checkbox" checked={values.remember_me} style={checkStyle}></Field>Remember me</span></div><br /><a href="/users/password/new">Forgot your password?</a><br /><br /><button type="submit" disabled={isSubmitting} className="col-sm-5">Log In</button><br /><br /><a href="/create_account">You do not have an account? Create one here</a><br /><br /></Form></div></div></Fragment>}</Formik>

export default LoginForm
